module.exports = __webpack_public_path__ + "img/bg-slide-4.bf55c646.jpg";